import React from "react";
import { MediumDistributionChart } from "./Chart";
import { SinglePageView } from "../core/ListView";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { useGamePlayTests } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const MediumDistribution = ({ gameId }) => {
  const { data: playTests = [] } = useGamePlayTests(gameId);

  const playTestsWithMedium = playTests.filter((pt) => pt.ignore && pt.medium);
  const incompletePlayTests = playTests.filter((pt) => !pt.medium && pt.ignore);

  return (
    <SinglePageView title={`In-Person vs Digital Play Tests`}>
      {playTestsWithMedium.length === 0 ? (
        <Box p={1}>
          <Alert severity="warning">
            To use this chart you need to record medium (in-person/digital) for your play tests. Update your play tests
            to include medium information.
          </Alert>
        </Box>
      ) : (
        <Box p={1}>
          <Alert severity="info">
            This chart shows the distribution of play tests by medium type (in-person vs digital). Only play tests with
            recorded medium are included.
            {incompletePlayTests.length > 0 && (
              <>
                {" "}
                There are {incompletePlayTests.length} play test{incompletePlayTests.length === 1 ? "" : "s"} without
                medium data.
              </>
            )}
          </Alert>
        </Box>
      )}
      <MediumDistributionChart gameId={gameId} />
    </SinglePageView>
  );
};
